import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withTranslation } from 'react-i18next';
import customerActions from '../../../Actions/customerActions';
import BlikkProducts from '../../../Components/Customer/BlikkProducts';
import SubscriptionCard from '../../../Components/Card/SubscriptionCard';
import InactiveProducts from '../../../Components/Products/InactiveProducts';
import Tooltip, { TooltipContent, TooltipTrigger } from '../../../Components/Overlays/Tooltip';
import helpers from "../../../Utils/helpers";
import {bindActionCreators} from "redux";
import useProductName from "../../../Hooks/useProductName";
import {blikkProductEdition} from "../../../Constants/producs";

const ThirdPartyProductsContainer = ({ t }) => {
    const dispatch = useDispatch();
    const customer = useSelector(state => state.CustomerReducer.customer);
    const blikkProducts = useSelector(state => state.CustomerReducer.blikkProducts);
    const blikkResponse = useSelector(state => state.CustomerReducer.blikkResponse);
    const blikkLoading = useSelector(state => state.CommonReducer.dataLoading.blikkData);
    const actions = bindActionCreators(customerActions, dispatch);
    const { translatedProductName } = useProductName();
    
    const customerNumber = customer?.vbCustomer?.customerNumber;

    useEffect(() => {
        actions.getPendingTerminationRequests(customerNumber);
        actions.getBlikkProducts(customerNumber);
    }, []);
    
    const renderThirdPartyProductsNoResponse = () => (
        <div className="d-flex justify-content-around">
            <Tooltip>
                <TooltipTrigger>
                    <span className={'pl-8 pr-16 pt-4 vismaicon vismaicon-sm vismaicon-filled vismaicon-warning'} aria-hidden="true" />
                </TooltipTrigger>
                <TooltipContent>
                    <strong>{t("thirdpartyproductscontainer.cantaccess", { value1: translatedProductName(blikkProductEdition.Business), value2: translatedProductName(blikkProductEdition.Pro) })}</strong> <span>{t("thirdpartyproductscontainer.message")}</span>
                </TooltipContent>
            </Tooltip>
        </div>
    );

    const getHeaderContent = () => {
        if (!blikkLoading && !blikkResponse) {
            return renderThirdPartyProductsNoResponse();
        }
        return null;
    };

    const mapInactiveProducts = () => {
        const invalidProducts = blikkProducts?.filter(product => product.canceledDate) || [];
        return invalidProducts.map(product => ({
            product: product.productDescription,
            purchaseDate: helpers.formatDate(product.activationDate),
            endDate: helpers.formatDate(product.currentPeriodEndDate),
        }));
    };

    const showBlikkProducts = blikkProducts && blikkProducts.length > 0 && !blikkLoading;

    return (
        <SubscriptionCard
            title={t("thirdpartyproductscontainer.thirdpartyproducts")}
            headerContent={getHeaderContent()}
            activeContent={showBlikkProducts && <BlikkProducts products={blikkProducts.filter(product => !product.canceledDate)} />}
            inactiveContent={<InactiveProducts products={mapInactiveProducts()} />}
            isLoading={blikkLoading}
        >
            {!showBlikkProducts && !blikkLoading && <h4>{t("thirdpartyproductscontainer.nothirdpartyproducts")}</h4>}
        </SubscriptionCard>
    );
};

export default withTranslation()(ThirdPartyProductsContainer);